import { LegalLayout } from "../components/legal-layout.js";

const SECTIONS = [
  { id: "policy", label: "Policy" },
  { id: "notice", label: "Filing a notice" },
  { id: "counter", label: "Counter-notification" },
  { id: "repeat", label: "Repeat infringers" },
  { id: "india", label: "India — IT Rules" },
  { id: "contact", label: "Contact" },
] as const;

export function Dmca() {
  return (
    <LegalLayout title="DMCA / Copyright Policy" updated="August 21, 2026" sections={SECTIONS}>
      <section id="policy" className="docs2__section">
        <h2>Policy</h2>
        <p>
          Routing Run Private Limited, operator of saucer.sh, respects the intellectual
          property rights of others and expects users to do the same. We respond to clear
          notices of alleged copyright infringement in a manner consistent with the U.S. Digital
          Millennium Copyright Act (DMCA) and, because we are an India-incorporated company,
          the Indian Copyright Act, 1957 and the IT (Intermediary Guidelines) Rules.
        </p>
      </section>

      <section id="notice" className="docs2__section">
        <h2>Filing a takedown notice</h2>
        <p>
          If you believe content hosted on saucer.sh infringes your copyright, email{" "}
          <a href="mailto:dmca@saucer.sh">dmca@saucer.sh</a> with:
        </p>
        <div className="cmdrows">
          <div className="cmdrows__row">
            <code className="mono">1</code>
            <span>A physical or electronic signature of the copyright owner or their authorized agent.</span>
          </div>
          <div className="cmdrows__row">
            <code className="mono">2</code>
            <span>Identification of the copyrighted work claimed to have been infringed.</span>
          </div>
          <div className="cmdrows__row">
            <code className="mono">3</code>
            <span>The saucer.sh URL(s) of the material you claim is infringing.</span>
          </div>
          <div className="cmdrows__row">
            <code className="mono">4</code>
            <span>Your contact information — address, phone number, and email.</span>
          </div>
          <div className="cmdrows__row">
            <code className="mono">5</code>
            <span>A statement that you have a good-faith belief the use is not authorized.</span>
          </div>
          <div className="cmdrows__row">
            <code className="mono">6</code>
            <span>A statement, under penalty of perjury, that the notice is accurate and you are authorized to act.</span>
          </div>
        </div>
        <p>
          On receiving a complete notice we remove or disable access to the link — deletion on
          saucer.sh is immediate, so the URL stops resolving as soon as we act — and notify the
          uploader.
        </p>
      </section>

      <section id="counter" className="docs2__section">
        <h2>Counter-notification</h2>
        <p>
          If your content was removed and you believe this was a mistake or misidentification,
          you may send a counter-notice to <a href="mailto:dmca@saucer.sh">dmca@saucer.sh</a>{" "}
          including your signature, identification of the removed material and its former
          location, a statement under penalty of perjury that you believe removal was in error,
          and your consent to the jurisdiction of the courts described in our{" "}
          <a href="/terms">Terms of Service</a>. We may restore the content after a waiting
          period unless the original complainant files legal action to prevent it.
        </p>
      </section>

      <section id="repeat" className="docs2__section">
        <h2>Repeat infringers</h2>
        <p>
          We terminate, in appropriate circumstances, accounts of users who are repeat
          infringers.
        </p>
      </section>

      <section id="india" className="docs2__section">
        <h2>India — IT Rules</h2>
        <p>
          As required under the Information Technology (Intermediary Guidelines and Digital
          Media Ethics Code) Rules, 2021, saucer.sh acts on actionable complaints of copyright
          infringement, and information relating to sovereignty, security, or public order,
          received in writing at the address below, and removes or disables access to the
          identified content within the timelines prescribed by the Rules.
        </p>
      </section>

      <section id="contact" className="docs2__section">
        <h2>Contact</h2>
        <p>
          Copyright and takedown notices: <a href="mailto:dmca@saucer.sh">dmca@saucer.sh</a>.
          All other inquiries: <a href="mailto:email@saucer.sh">email@saucer.sh</a>.
        </p>
      </section>
    </LegalLayout>
  );
}
